import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RvdStatuses } from 'shared/enums/rvd';
import { TRvdGetResponse } from 'shared/types/rvd.types';

const initialState: TRvdGetResponse = {
  id: 0,
  count: 0,
  status: RvdStatuses.NOT_LOADED_CPRODUCT,
  employees: [],
  created: '',
  docSignatory: '',
};

export const rvdSlice = createSlice({
  name: 'rvd',
  initialState,
  reducers: {
    setCurrent: (state, { payload }: PayloadAction<TRvdGetResponse>) => {
      return payload;
    },
    clearCurrent: () => initialState,
  },
});

export const rvdActions = rvdSlice.actions;
export const reducer = rvdSlice.reducer;
